import React from "react";
import { STATES } from "../utils/use_game_state";

const Spinner = ({ gameState }) => gameState === STATES.LOAD &&
  <div className="absolute flex w-full h-full items-center bg-white bg-opacity-50"><div className="spinner-green" /></div>;

export default Spinner;
